import { isRestrictedArchitecture } from '../../image-vm/utils';

const DEFAULT_ARCH_OPTIONS = ['AMD64', 'ARM64'];

export function resolveArchitectureOptions(systemDiskRaw: unknown): string[] {
  if (!systemDiskRaw || typeof systemDiskRaw !== 'object') {
    return DEFAULT_ARCH_OPTIONS;
  }
  const disk = systemDiskRaw as { image?: { architecture?: string } };
  const arch = disk.image?.architecture;
  if (isRestrictedArchitecture(arch)) {
    return [String(arch).trim()];
  }
  return DEFAULT_ARCH_OPTIONS;
}
